import InvertProjectIcon from './component'

export default InvertProjectIcon
